import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { collection, getDocs, query, orderBy } from 'firebase/firestore';
import { db } from './firebase';
import Navbar from './components/Navbar';
import Home from './components/Home';
import EventSignUp from './components/EventSignUp';
import AdminSignIn from './components/AdminSignIn';
import CreateEvent from './components/CreateEvent';
import PromptLibrary from './components/PromptLibrary';
import Tutorials from './components/Tutorials';
import Sidebar from './components/Sidebar';

function App() {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    const fetchEvents = async () => {
      try {
        const eventsQuery = query(collection(db, 'events'), orderBy('createdAt', 'desc'));
        const querySnapshot = await getDocs(eventsQuery);
        const eventsData = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
        setEvents(eventsData);
      } catch (error) {
        console.error('Error fetching events:', error);
      }
    };

    fetchEvents();
  }, []);
  return (
    <Router>
      <div style={{ minHeight: '100vh', backgroundColor: '#f8f9fa' }}>
        <Navbar />
        <div style={{ paddingTop: '80px', display: 'flex' }}>
          <div style={{ flex: 1, marginRight: '350px' }}>
            <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/events" element={<EventSignUp />} />
            <Route path="/tutorials" element={<Tutorials />} />
            <Route path="/admin" element={<AdminSignIn />} />
            <Route path="/admin/create-event" element={<CreateEvent />} />
            <Route path="/prompt-library" element={<PromptLibrary />} />
            </Routes>
          </div>
          
          <Sidebar events={events} />
        </div>
      </div>
    </Router>
  );
}

export default App;
